import { useQuery } from 'react-query'
import { customerTypeahead } from 'services/cm-api/customer-typeahead'

/**
 * Drives the member-picker typeahead inside the customer-group
 * dialog. Skipped entirely when the query string is empty so we
 * don't spam the CMAPI on every dialog open.
 *
 * `keepPreviousData` smooths over the brief gap between successive
 * keystrokes — without it the dropdown blanks out on every fetch.
 */
export function useCustomerTypeahead(q: string) {
  const trimmed = q.trim()

  return useQuery(
    ['customer-typeahead', trimmed],
    () => customerTypeahead(trimmed),
    {
      enabled:
        trimmed.length > 0 && Boolean(localStorage.getItem('FB_ACCESS_TOKEN')),
      keepPreviousData: true,
      // Typeahead results are cheap to refetch and operators expect
      // them to feel fresh — keep the cache window short.
      staleTime: 5_000,
    },
  )
}
